<template>
	<div class="com-list-content">
		<!-- <com-search :model="search" :transfer-model.sync="condition" v-slot="{data}" :table="$refs.table">
			<ui-text v-model="data.createTime" label="创建时间"/>
			<ui-template>
				<ui-button type="search"></ui-button>
			</ui-template>
		</com-search> -->
		<com-table ref="table" url="/admin/wrong/list" :search="condition" v-slot="{data}">
		    <el-table-column type="expand">
                <template slot-scope="props">
                  <div class="table-expand">
					<div class="table-expand-title">答案文字</div>
					<div class="table-expand-line1"></div>
					<div class="table-expand-line2"></div>
					<div class="table-expand-text" v-if="props.row.answerContent!=''">{{props.row.answerContent}}</div>
					<div class="table-expand-empty" v-else-if="props.row.answerContent==''">
						<img src="@/assets/img/empty.png" alt="">
					    <span>暂无数据</span>
					</div>
                  </div>
                </template>
            </el-table-column>
			<ui-text v-model="data.id" label="ID" width="100"/>
			<ui-image v-model="data.titleImg" label="题干"/>
			<ui-image v-model="data.faceImg" label="答案照片"/>
			<ui-text v-model="data.subjectName" label="科目"/>
			<ui-select v-model="data.mastery" tag label="掌握程度">
				<ui-option value="0" text="不会" tag-type="danger"/>
				<ui-option value="1" text="生疏" tag-type="warning"/>
				<ui-option value="2" text="熟练" tag-type="success"/>
			</ui-select>
			<ui-text v-model="data.userName" label="用户"/>
			<ui-date v-model="data.createTime" type="datetime" label="创建时间"/>
			<ui-template label="操作">
				<ui-button type="delete" @click="remove(data)"/>
			</ui-template>
		</com-table>
	</div>
</template>

<script>

export default {
	data(){
		return {
			search:{},
			condition:{},
		};
	},
	mounted(){
		console.log(this.data)
	},
	methods:{
		remove(data){
			this.$axios.delete('/admin/wrong/option/'+data.id)
			.then(data=>{
				this.$refs.table.refresh();
			}).end();
		}
	}
}
</script>

<style>
	.table-expand {
		box-shadow: 3px 3px 7px rgba(64,158,255,.2);
		border-radius: 3px;
	}
	.table-expand-title {
		padding-top: 10px;
		padding-left: 10px;
		font-size: 20px;
		font-weight: bold;
	}
	.table-expand-line1,
	.table-expand-line2 {
		width: 80px;
		border: 1px dashed rgba(64,158,255,.2);
	}
	.table-expand-line1 {
		margin: 5px 0 0 30px;
	}
	.table-expand-line2 {
		margin: 5px 0 0 35px;
	}
	.table-expand-text {
		width: 90%;
		margin: 0 auto;
		padding: 30px 0;
		line-height: 25px;
	}
	.table-expand-empty {
		padding: 30px 0;
		text-align: center;
	}
	.table-expand-empty span {
		display: block;
	}
</style>
